import React from "react";

import { TextButton } from "../../../common/Typography";
import mailIcon from "../../../common/Typography/assets/mail.svg";

function OtpUserChangeRow({ user, changeAccountLabel, onChangeAccount }) {
  return (
    <div className={"flex flex-row gap-2 align-center"}>
      <img
        src={mailIcon}
        alt={""}
        width={16}
        height={16}
        className={"flex-shrink-0"}
      />
      <p className={"text-sm line-height-160 font-medium text-black mb-0"}>
        {user}{" "}
        <TextButton className={"ml-2"} onClick={onChangeAccount}>
          {changeAccountLabel}
        </TextButton>
      </p>
    </div>
  );
}

export default OtpUserChangeRow;
